export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10357.d78f5922.jpg";